import { app } from '../../../../../../app';
import { Controller } from './user-settings.controller';

app.component('companyUserDirectoriesSaaspassUsersUserSettings', {
    bindings: {companyId: '<',userSettings:'<'},
    controller: Controller,
    templateUrl: require('./user-settings.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/all-users/user-settings/user-settings.component.js